angular.
module("dx.webapp.kayako").
factory("dxKayako", function kayakoService(
	$window,
	$timeout,
	$rootScope,

	dxRegion,

	dxLocalize
) {
	"use strict";

	var kayako = $window.kayako;
	var animating = false;
	var BUTTON_TIMEOUT = 300;
	var hidden = true;
	var supportEmail = dxRegion.getCurrent().key === "USA" ? "support@digiexam.com" : "support@digiexam.se";

	if (kayako) {
		kayako.ready(function onReady() {
			// There is currently a bug where the visibility state gets stuck as maximized if the page is reloaded
			// while the messenger is maximized. Avoid this by also showing and hiding the messenger.
			kayako.hide();
		});
	}

	// If you just want to identify user, set 'name' and 'email', and pass 'signature' as an empty string.
	// If you also want to make all existing user conversations available in Messenger, send a valid 'signature'.
	function identify(authData) {
		kayako.ready(function onReady() {
			// timestamp: Number (Unix timestamp in seconds)
			kayako.identify(authData.name, authData.email, authData.signature, authData.timestamp);

			kayako.on("unread_messages_count_changed", function messageCountUpdate(count) {
				$rootScope.$broadcast("kayako.newMessage", count);
			});
		});
	}

	function logout() {
		kayako.ready(function onReady() {
			// Reset button when logging out
			if (!isClosed()) {
				close();
			}

			kayako.forget();
		});
	}

	function show() {
		hidden = false;
		$rootScope.$broadcast("kayako.visible");
	}

	function hide() {
		hidden = true;
		$rootScope.$broadcast("kayako.hidden");
	}

	function isHidden() {
		return hidden;
	}


	function open() {
		// Inform the user how to contact support if Kayako failed to initialize correctly due to some issue on their end.
		if (!kayako || !kayako.show || !kayako.maximize) {
			$rootScope.$emit("notification:error", dxLocalize.get("Support.Error", supportEmail));
			return;
		}

		kayako.ready(function onReady() {
			animating = true;
			kayako.show();
			kayako.maximize();
			angular.element(".kayako").addClass("kayako-visible");
			angular.element(".kayako").removeClass("kayako-hidden");

			$timeout(function hideButton() {
				animating = false;
			}, BUTTON_TIMEOUT);
		});
	}

	function close() {
		kayako.ready(function onReady() {
			kayako.minimize();
			angular.element(".kayako").removeClass("kayako-visible");
			angular.element(".kayako").addClass("kayako-hidden");
			animating = true;

			// To allow the minimize animation to play fully, hide the messenger with a timeout.
			$timeout(function hideButton() {
				animating = false;
				kayako.hide();
			}, BUTTON_TIMEOUT);
		});
	}

	function isClosed() {
		// Avoid console error if Kayako failed to initialize correctly due to some issue on their end.
		if (!kayako.visibility) {
			return false;
		}

		var visibility = kayako.visibility();

		// Kayako has hard coded string states for visibility:
		// maximized, minimized, hidden
		switch (visibility) {
			case "minimized":
			case "hidden":
				return true;
		}
		return false;
	}

	function toggleChat() {
		if (animating) {
			return;
		}

		isClosed() ? open() : close();
	}

	return {
		login: identify,
		logout: logout,
		show: show,
		hide: hide,
		isHidden: isHidden,
		toggleChat: toggleChat,
	};
});
